import React, { useCallback } from 'react'
import useNavigation from 'hooks/useNavigation'
import { setShowDrawerSuccess } from 'store/modals/actions'
import { showDrawer as showDrawerAction } from 'store/drawer/actions'
import { useDispatch } from 'react-redux'
import {
  Drawer,
  Container,
  ButtonStyled,
  Title,
  Body,
  ContentContainer,
  Header,
  SuccessTick,
  Clock,
  HeaderLabel,
  ExtraInfoRow,
  ExtraInfoText,
  BackButton
} from './style'
import BackArrowIcon from '@qirapagos/web/src/assets/svg/BackArrow'
import { useAppSelector } from 'hooks/redux'
import ButtonLine from 'components/atoms/ButtonLine'
import { Box } from '@chakra-ui/react'
import { Drawers } from 'store/drawer/types'

const DrawerSuccess: React.FC = () => {
  const { showDrawerSuccess } = useAppSelector(state => state.modal)
  const { title, body, showBackArrow } = showDrawerSuccess
  const { movements, isLoading } = useAppSelector(state => state.transfers)
  const dispatch = useDispatch()
  const { onNavigate } = useNavigation()

  const onClose = useCallback(() => {
    dispatch(setShowDrawerSuccess(false, true, ''))
    onNavigate(showDrawerSuccess?.navigation?.path, {
      title: showDrawerSuccess?.navigation?.title
    })
  }, [dispatch, onNavigate, showDrawerSuccess])

  const handlePressBack = useCallback(
    (path: string, fromInvestments = false) => {
      dispatch(setShowDrawerSuccess(false, true, ''))

      fromInvestments
        ? onNavigate(path, { title: 'Inversiones' })
        : onNavigate(path)
    },
    [dispatch, onNavigate]
  )

  const onPressReceipt = useCallback(() => {
    // Validation added to correctly display the transfer receipt when there is taxes
    const movementIndex = movements[0].movementType.id === 7 ? 1 : 0
    const movement = movements[movementIndex]

    const drawerInfo = {
      date: movement?.timestamp,
      amount: movement?.amount,
      cbu: movement?.cbu || '',
      cuit: movement?.cuit,
      id: movement?.id,
      owner: movement?.owner,
      movementType: movement?.movementType,
      status: movement?.status
    }

    dispatch(setShowDrawerSuccess(false, true, ''))
    dispatch(showDrawerAction(Drawers.RECEIPT_DETAIL, drawerInfo))
  }, [dispatch, movements])

  const renderList = () => {
    if (showDrawerSuccess.navigation?.fromScreen === 'transfer') {
      return (
        <Box display="flex" flexDir="column" width="100%">
          <ButtonLine
            onPress={() => handlePressBack('/content/wallet')}
            marginBottom={20}
          >
            Volver al inicio
          </ButtonLine>
          <ButtonStyled
            onPress={onPressReceipt}
            disabled={isLoading}
            loading={isLoading}
          >
            Ver comprobante
          </ButtonStyled>
        </Box>
      )
    }
    if (showDrawerSuccess.navigation?.fromScreen === 'myContacts') {
      return (
        <ButtonLine onPress={onClose} disabled={false} marginBottom={40}>
          Volver al inicio
        </ButtonLine>
      )
    }
    if (showDrawerSuccess.navigation?.fromScreen === 'investments') {
      return (
        <Box display="flex" flexDir="column" width="100%">
          <ButtonLine
            onPress={() => handlePressBack('/content/wallet')}
            marginBottom={20}
          >
            Volver al inicio
          </ButtonLine>
          <ButtonStyled
            onPress={() => {
              handlePressBack('/content/investments', true)
            }}
            disabled={isLoading}
            loading={isLoading}
          >
            Volver a inversiones
          </ButtonStyled>
        </Box>
      )
    }
    return (
      <Box display="flex" flexDir="column" width="100%">
        <ButtonLine
          onPress={() => handlePressBack('/content/wallet')}
          disabled={false}
          marginBottom={20}
        >
          Volver al inicio
        </ButtonLine>
        <ButtonStyled onPress={onClose} disabled={false}>
          Continuar
        </ButtonStyled>
      </Box>
    )
  }

  return (
    <Drawer open={showDrawerSuccess?.show} onClose={onClose} direction="right">
      <Container>
        {showBackArrow && (
          <BackButton
            onClick={() => {
              if (!isLoading) onClose()
            }}
          >
            <BackArrowIcon />
          </BackButton>
        )}
        <Header>
          {showDrawerSuccess.navigation?.title && (
            <HeaderLabel>{showDrawerSuccess.navigation.title}</HeaderLabel>
          )}
        </Header>
        <ContentContainer>
          <SuccessTick />
          <Title>{title}</Title>
          {body && (
            <Body $compact={showDrawerSuccess.navigation?.title === 'Rescate'}>
              {body}
            </Body>
          )}
          {showDrawerSuccess.navigation?.title === 'Rescate' && (
            <ExtraInfoRow>
              <Clock />
              <ExtraInfoText>
                El saldo se actualizará una vez procesado el rescate, según el
                horario de corte.
              </ExtraInfoText>
            </ExtraInfoRow>
          )}
        </ContentContainer>
        {renderList()}
      </Container>
    </Drawer>
  )
}

export default DrawerSuccess
